import { render } from "./editNews.vue?vue&type=template&id=b156ed28&scoped=true"
import script from "./editNews.vue?vue&type=script&lang=js"
export * from "./editNews.vue?vue&type=script&lang=js"

import "./editNews.vue?vue&type=style&index=0&id=b156ed28&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\jll-web-xintan\\official-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b156ed28"]])

export default __exports__